import moment from 'moment';

export function getAge(birthDate: string) {
  const age = moment().diff(moment(birthDate), 'years');
  return age;
}
